import React, { useState, useEffect } from "react";

import { InputGroup } from "react-bootstrap";

import moment from "moment";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import List from "./Userlist.js";
import NurseryDetail from "./NurseryDetail";

import ViewOption from "./Componenet/ViewOption.js";

import * as util from "@app/lib/utility";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";
import * as commonData from "@app/lib/common_data";
import { da, pl } from "date-fns/locale";
const ROW_PER_PAGE = 18;
const date = new Date();

const Subscriber = ({}) => {
    const [loadingData, setLoadingData] = useState(true);
    const [isRoleBranch, setIsRoleBranch] = useState(false);
    const [serviceAppList, setServiceAppList] = useState(null);
    const [appAuthTypeList, setAppAuthTypeList] = useState(null);
    const [branches, setBranches] = useState(null);
    const [nurseries, setNurseries] = useState(null);
    const [data, setData] = useState(null);
    const [tableData, setTableData] = useState(null);
    const [deviceData, setDeviceData] = useState(null);
    const [page, setPage] = useState(null);
    const [selectedViewOption, setSelectedViewOption] = useState(-1);
    const [selectedViewSubOption, setSelectedViewSubOption] = useState(-1);
    const [keyword, setKeyword] = useState("");
    const [searchType, setSearchType] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const [searchCount, setSearchCount] = useState(0);
    const [selectedBranchId, setSelectedBranchId] = useState(null)
    const [selectedNurseryId, setSelectedNurseryId] = useState(null);
    const [selectedNurseryName, setSelectedNurseryName] = useState(null);
    const [isBack, setIsBack] = useState(false);
    const [adjustmenting, setAdjustmenting] = useState(false);
    const currentYear = date.getMonth() < 5 ? date.getFullYear() - 1: date.getFullYear() ;


    const searchTypeList = [
        { name: "계정", id: "user_id" },
        { name: "원 명", id: "nursery" },
        { name: "DID", id: "did" },
        { name: "반 명", id: "class" },
    ];

    useEffect(() => {
        const isRoleBranch = util.isRoleBranch();

        if (isRoleBranch) {
            const logInfo = util.getLoginBranchInfo();
            //branchName = logInfo.name;
            setIsRoleBranch(isRoleBranch);
            setSelectedViewOption(logInfo.id);
            setSelectedBranchId(logInfo.id);
            getUserTotalCount(logInfo.id);
        }
        if (!isRoleBranch) getUserTotalCount(-1);
        if (!serviceAppList && !appAuthTypeList && !branches) {
            getBaseInfo();
        }
        setSearchType(searchTypeList[0].id);
        return () => {};
    }, []);

    useEffect(() => {
        if (selectedViewOption != null && selectedViewOption != "none") getNurseryList();
        else setNurseries([{ name: "원을 선택해 주세요", id: "none" }]);
    }, [selectedViewOption]);

    useEffect(() => {
        if (serviceAppList && appAuthTypeList && branches) {
            getData();
        }
        return () => {};
    }, [serviceAppList, appAuthTypeList, branches, selectedViewOption, selectedViewSubOption, page]);

    useEffect(() => {
        return () => {};
    }, [keyword, page, selectedNurseryId]);

    const getBaseInfo = () => {
        setLoadingData(true);
        commonData.getAppAuthTypeList(axios, (err, typeList) => {
            if (!err) {
                setAppAuthTypeList(typeList);
                commonData.getServiceAppList(axios, (err1, appList) => {
                    if (!err1) {
                        setServiceAppList(appList);
                        commonData.getBranchList(axios, (err2, branchList) => {
                            if (!err2) {
                                branchList.unshift({ name: "지사를 선택해 주세요", id: "none" });
                                setBranches(branchList);
                            } else {
                                console.log(err2);
                                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                            }
                            setLoadingData(false);
                        });
                    } else {
                        console.log(err1);
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                        setLoadingData(false);
                    }
                });
            } else {
                console.log(err);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            }
        });
    };

    const getUserTotalCount = (branchId) => {
        setAdjustmenting(true);

        axios({
            method: "get",
            url: `/api/subscriber/user/count/${branchId}`,
            data: {},
        })
            .then((res) => {
                setTotalCount(res.data.count);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
        setAdjustmenting(false);
    };

    const getNurseryList = () => {
        setLoadingData(true);
        axios({
            method: "GET",
            url: `/api/subscriber/nursery/list/${selectedViewOption}`,
            data: {},
        })
            .then((res) => {
                if (res.data && res.data.nursery && res.data.nursery.length > 0) {
                    res.data.nursery.sort((a, b) => {
                        if (a.name < b.name) {
                            return -1;
                        } else if (a.name > b.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }

                res.data.nursery.unshift({ name: "원을 선택해 주세요", id: "none" });
                setNurseries(res.data.nursery);
            })
            .catch((err) => {
                console.log(err);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };

    const getData = () => {
        // toast.info("데이터를 가져옵니다.");
        setLoadingData(true);
        axios({
            method: "POST",
            url: `/api/subscriber/user/list`,
            data: {
                branchId: selectedViewOption != "none" ? selectedViewOption : -1,
                nurseryId: selectedViewSubOption != "none" ? selectedViewSubOption : null,
                searchType: searchType,
                keyword: keyword,
                row: ROW_PER_PAGE,
                page: page,
            },
        })
            .then((res) => {
                if (res.data && res.data.subscriber && res.data.subscriber.length > 0) {
                    res.data.subscriber.forEach((s, index) => {
                        s.rowIndex = page * ROW_PER_PAGE + index + 1;
                    });
                }
                let combineData = combineAppAuth(res.data.subscriber, res.data.ddChildCount, res.data.appAuth);
                setData(combineData);
                setTableData(combineData);
                setSearchCount(res.data.totalCount);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };

    const combineAppAuth = (subscriber, ddChildCount, authData) => {
        subscriber.forEach((s) => {                          
            var playDdChildCount = ddChildCount ? ddChildCount.find((c) =>c.class_id == s.class_id) : 0;
            if(playDdChildCount) s.ddChildCount = playDdChildCount.count;   
            else s.ddChildCount = 0;
            s.tomo_type = null;
            if(s.unionId) {
                s.unionInfo = appAuthTypeList.all.find((at) => s.unionId == at.id);
                if(s.unionInfo) {
                    s.tomo_type = s.unionInfo.type;
                }
            }
            s.all_branch_name = '';
            authData.forEach((a) => {
                if (s.sid == a.sid) {
                    if(a.approval == "AP"){
                        if (!s.all_branch_name)  s.all_branch_name = new Set(); 
                        if (a.branch_name) s.all_branch_name.add(a.branch_name);
                    }
                    const app = serviceAppList.find((app) => app.contractUseTas && app.key === a.app_id);
                    if(app) {
                        s[app.key] = a.approval;
                        s[`multi_use_count_${app.key}`] = a.multi_use_count ? a.multi_use_count : 0;
                        s[`${app.key}_branch`] = a.branch_name;
                        s[`${app.key}_branch_id`] = a.branch_id;
                        s[`${app.key}_start_date`] = a.start_date != null ? moment(a.start_date).format("YYYY-MM-DD") : "";
                        s[`${app.key}_end_date`] = a.end_date != null ? moment(a.end_date).format("YYYY-MM-DD") : "";
                        s[`${app.key}_approval_date`] = a.approval_date != null ? moment(a.approval_date).format("YYYY-MM-DD") : a.approval_date;
                        s[`${app.key}_contract_date`] = a.contract_date != null ? moment(a.contract_date).format("YYYY-MM-DD") : a.contract_date;
                        s[`${app.key}_contract_year`] = a.contract_year;
                        s[`${app.key}_recontract_year`] = a.recontract_year == null ? 0 : a.recontract_year;
                        s[`${app.key}_terminate_date`] = a.terminate_year;
                        var startDate = new Date(a.start_date);
                        s[`${app.key}_contract_start_year`] = startDate.getMonth() < 5 ? startDate.getFullYear() : startDate.getFullYear() + 1;
                    }
                }
            });
            s.all_branch_name = [...s.all_branch_name].join(", ");
        });

        return subscriber;
    }



    const onViewOptionSelected = (selected) => {
        setKeyword("");
        setPage(0);
        setSelectedViewOption(selected);
        setSelectedViewSubOption(null);
    };

    const onViewSubOptionSelected = (selected) => {
        setKeyword("");
        setPage(0);
        setSelectedViewSubOption(selected);
    };

    const onSearchTypeSelected = (selected) => {
        setSearchType(selected);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch(e.target.value);
        }
    };

    const onSearch = (e) => {
        if (page == 0) getData();
        setPage(0);
    };

    const onSelectPage = (selected) => {
        setPage(selected);
    };

    const onSelectedRow = (e) => {
        setSelectedNurseryName(e.data.nursery_uniq_name);
        setSelectedBranchId(e.data.branch_id);
        setSelectedNurseryId(e.data.nursery_uniq_id);
        setIsBack(false);
    };

    const onBackButton = () => {
        setSelectedNurseryId(null);
    };

    const onAdjustmenting = () => {
        setAdjustmenting(true);
        axios({
            method: "post",
            url: `/api/subscriber/user/list`,
            data: {
                branchId: selectedViewOption != "none" ? selectedViewOption : -1,
                nurseryId: selectedViewSubOption != "none" ? selectedViewSubOption : null,
                searchType: searchType,
                keyword: keyword,
                row: ROW_PER_PAGE,
                page: page,
                isAll: true,
            },
        })
            .then((res) => {
                let data = combineAppAuth(res.data.subscriber, res.data.ddChildCount, res.data.appAuth);
                saveAdjustmentXlsx(data);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setAdjustmenting(false);
            });
    };

    const onConsultAdjustmenting = () => {
        setAdjustmenting(true);
        axios({
            method: "post",
            url: `/api/subscriber/user/list`,
            data: {
                branchId: selectedViewOption != "none" ? selectedViewOption : -1,
                nurseryId: selectedViewSubOption != "none" ? selectedViewSubOption : null,
                searchType: searchType,
                keyword: keyword,
                row: ROW_PER_PAGE,
                page: page,
                isAll: true,
            },
        })
            .then((res) => {
                let data = combineAppAuth(res.data.subscriber, res.data.ddChildCount, res.data.appAuth);
                saveConsultAdjustmentXlsx(data);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setAdjustmenting(false);
            });
    };

    const saveConsultAdjustmentXlsx = (list) => {
        //console.log(list)
        let fileNameOrg = `TAS정산참고자료_${date.getFullYear()}${date.getMonth() + 1 < 10 ?"0"+ (date.getMonth() + 1) : date.getMonth() + 1}${date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()}`;
        let fileName = null;
        if (!list || list.length === 0) {
            alert("정산 목록이 없습니다.");
            return false;
        } else {
            fileName = window.prompt(
                "파일명을 입력해주세요",fileNameOrg
            );
            fileName = fileName == null || fileName == "" ? fileNameOrg : fileName;
        }

        const excelHandler = {
            getExcelData() {
                const excelData = {
                    fileName: fileName + ".xlsx",
                    sheets: [
                        {
                            name: "계약 상세 내용",
                            columnTitle: [
                                "ID",
                                "userId",
                                "이름",
                                "타입",
                                "원(기관)",
                                "유형",
                                "분류",
                                "반명",
                                "주소",
                                "기관전화번호",
                                "지사명",
                                "계약지사",
                                "계약원아수",
                                "결합상품",
                                "토모노트",
                                "클래스",
                                "클래스 원아 수",
                                "꾸러미 결합",
                                "꾸러미 원아수",
                                "별별책방 결합",
                                "별별책방 원아수",
                                "한글수 결합",
                                "한글수 원아수",
                                "젤링 결합",
                                "젤링 원아수",
                                "플레이딩동 단독",
                                "딩동 원아수",
                                "모모한글수 단독",
                                "젤링 단독",
                                "별별책방 단독",
                                "플라잉 단독",
                                "플라잉 원아수",
                            ],
                            data: list
                                ? list.map((s, idx) => [
                                      s.sid,
                                      s.user_id,
                                      s.name,
                                      s.role,
                                      s.nursery_uniq_name,
                                      s.type == "S" ? "유치원" : s.type == "A" ? "어린이집" : "기타",
                                      s.sub_type,
                                      s.class_name,
                                      s.address,
                                      s.tel,
                                      s.all_branch_name,
                                      s.branchCount,
                                      s.quantity ? s.quantity : 0,
                                      s.unionInfo ? s.unionInfo.name : '-',
                                      s.tomonote == "AP" ? "사용" : "미사용",
                                      s.tomonote == "AP" ? s.tomo_type == "class" ? 1 : 0 : 0,
                                      s.tomonote == "AP" ? s.tomo_type == "class" ? s.quantity ? s.quantity : 0 : 0 : 0,
                                      s.tomonote == "AP" ? s.tomo_type == "books" ? 1 : 0 : 0,//꾸러미
                                      s.tomonote == "AP" ? s.tomo_type == "books" ? s.quantity ? s.quantity : 0 : 0 : 0,
                                      s.tomonote == "AP" ? s.tomo_type == "bookstore" ? 1: 0 : 0,//별별
                                      s.tomonote == "AP" ? s.tomo_type == "bookstore" ? s.quantity ? s.quantity : 0 : 0 : 0,
                                      s.tomonote == "AP" ? s.tomo_type == "momo" ? 1 : 0 : 0,//한글수
                                      s.tomonote == "AP" ? s.tomo_type == "momo" ? s.quantity ? s.quantity : 0 : 0 : 0,
                                      s.tomonote == "AP" ? s.tomo_type == "jelliing" ? 1 : 0 : 0,//젤링
                                      s.tomonote == "AP" ? s.tomo_type == "jelliing" ? s.quantity ? s.quantity : 0 : 0 : 0,
                                      s.playdd == "AP" ? 1 : 0, //플레이딩동 단독
                                      s.playdd == "AP" ? s.ddChildCount : 0 ,
                                      s.momo == "AP" ? 1 : 0,
                                      s.jelliing == "AP" ? 1 : 0,
                                      s.tomobooks == "AP" ? 1 : 0,
                                      s.tomoenglish == "AP" ? 1 : 0,
                                      s.e_quantity ? s.e_quantity : 0//플라잉 원아 수
                                  ])
                                : [],
                        },
                    ],
                };
                return excelData;
            },
        };
        var wb = XLSX.utils.book_new();
        var excelData = excelHandler.getExcelData();
        excelData.sheets.forEach((s) => {
            var ws = XLSX.utils.aoa_to_sheet([]);
            XLSX.utils.sheet_add_aoa(ws, [excelData.sheets[0].columnTitle], { origin: { r: 0, c: 0 } });
            XLSX.utils.sheet_add_json(ws, s.data, { origin: { r: 1, c: 0 }, skipHeader: true });

            XLSX.utils.book_append_sheet(wb, ws, s.name);
        });

        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        util.download2Excel(wbout, excelData.fileName);

        setAdjustmenting(false);
    };

    const saveAdjustmentXlsx = (list) => {
        let fileNameOrg = `TAS계약상세정보_${date.getFullYear()}${date.getMonth() + 1 < 10 ?"0"+ (date.getMonth() + 1) : date.getMonth() + 1}${date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()}`;
        let fileName = null;
        if (!list || list.length === 0) {
            alert("정산 목록이 없습니다.");
            return false;
        } else {
            fileName = window.prompt(
                "파일명을 입력해주세요",fileNameOrg
            );
            fileName = fileName == null || fileName == "" ? fileNameOrg : fileName;
        }

        const excelHandler = {
            getExcelData() {
                const excelData = {
                    fileName: fileName + ".xlsx",
                    sheets: [
                        {
                            name: "계약 상세 내용",
                            columnTitle: [
                                "ID",
                                "userId",
                                "이름",
                                "타입",
                                "원(기관)",
                                "유형",
                                "분류",
                                "반명",
                                "주소",
                                "기관전화번호",
                                "휴대폰",
                                "지사명",
                                "계약지사",
                                "결합상품",
                                "토모노트",
                                "승인연령",
                                "통합 원아수",
                                "토모노트계약",
                                "DID",
                                "디바이스 접속",
                                "TAS 디바이스",
                                "기기 정보(모델명)",
                                "가입일자",
                                "계약일",
                                "미사용 변경일",
                                "계약연도",
                                "토모노트 지사",
                                "토모노트 계약 구분",
                                "딩동",
                                "딩동 계약기간",
                                "딩동지사",
                                "딩동 계약구분",
                                "momo",
                                "momo 계약기간",
                                "momo 지사",
                                "momo 계약구분",
                                "젤링",
                                "젤링 계약기간",
                                "젤링 지사",
                                "젤링 계약구분",
                                "별별책방",
                                "별별책방 계약기간",
                                "별별책방 지사",
                                "별별책방 계약구분",
                                "플라잉",
                                "플라잉 승인연령",
                                "플라잉 원아수",
                                "플라잉 지사",
                                "플라잉 계약구분",
                            ],
                            data: list
                                ? list.map((s, idx) => [
                                      s.sid,
                                      s.user_id,
                                      s.name,
                                      s.role,
                                      s.nursery_uniq_name,
                                      s.type == "S" ? "유치원" : s.type == "A" ? "어린이집" : "기타",
                                      s.sub_type,
                                      s.class_name,
                                      s.address,
                                      s.tel,
                                      s.mobile,
                                      s.all_branch_name,
                                      s.branchCount,
                                      s.unionInfo ? s.unionInfo.name : '-',
                                      s.tomonote == "AP" ? "승인" : "미사용",
                                      s.age != null ? (s.age == 123 ? "혼합" : "만" + (s.age + 2) + "세") : "-",
                                      s.tomonote == "AP" ? s.quantity : "-",
                                      s.tomonote == "AP" ? s.tomonote_start_date + "~" + s.tomonote_end_date : "~",
                                      s.did,
                                      s.last_access,
                                      s.device == "board" ? "전자칠판" : s.device == "tablet" ? "타블렛" : "-",
                                      s.firmware,
                                      s.create_date ? moment(s.create_date).format("YYYY-MM-DD") : "",
                                      s.tomonote_contract_date ? s.tomonote_contract_date : "",
                                      s.tomonote_terminate_date ? s.tomonote_terminate_date : "",
                                      s.tomonote_contract_start_year,
                                      s.tomonote_branch,
                                      s.tomonote == "AP"
                                          ? s.tomonote_start_date > currentYear + "-06-01"
                                              ? "신규"
                                              : (s.tomonote_recontract_year == 0 || s.tomonote_recontract_year < currentYear)
                                              ? "재계약"
                                              : "재계약확정"
                                          : "-",
                                      s.playdd == "AP" ? "승인" : "미사용",
                                      s.playdd == "AP" ? s.playdd_start_date + "~" + s.playdd_end_date : "~",
                                      s.playdd == "AP" ? s.playdd_branch : "",
                                      s.playdd == "AP"
                                          ? s.playdd_start_date > currentYear + "-06-01"
                                              ? "신규"
                                              : (s.playdd_recontract_year == 0 || s.playdd_recontract_year < currentYear)
                                              ? "재계약"
                                              : "재계약확정"
                                          : "-",
                                      s.momo == "AP" ? "승인" : "미사용",
                                      s.momo == "AP" ? s.momo_start_date + "~" + s.momo_end_date : "~",
                                      s.momo == "AP" ? s.momo_branch : "",
                                      s.momo == "AP"
                                          ? s.momo_start_date > currentYear + "-06-01"
                                              ? "신규"
                                              : (s.momo_recontract_year == 0 || s.momo_recontract_year < currentYear)
                                              ? "재계약"
                                              : "재계약확정"
                                          : "-",
                                      s.jelliing == "AP" ? "승인" : "미사용",
                                      s.jelliing == "AP" ? s.jelliing_start_date + "~" + s.jelliing_end_date : "~",
                                      s.jelliing == "AP" ? s.jelliing_branch : "",
                                      s.jelliing == "AP"
                                          ? s.jelliing_start_date > currentYear + "-06-01"
                                              ? "신규"
                                              : (s.jelliing_recontract_year == 0 || s.jelliing_recontract_year < currentYear)
                                              ? "재계약"
                                              : "재계약확정"
                                          : "-",
                                      s.tomobooks == "AP" ? "승인" : "미사용",
                                      s.tomobooks == "AP" ? s.tomobooks_start_date + "~" + s.tomobooks_end_date : "~",
                                      s.tomobooks == "AP" ? s.tomobooks_branch : "-",
                                      s.tomobooks == "AP"
                                          ? s.tomobooks_start_date > currentYear + "-06-01"
                                              ? "신규"
                                              : (s.tomobooks_recontract_year == 0 || s.tomobooks_recontract_year < currentYear)
                                              ? "재계약"
                                              : "재계약확정"
                                          : "-",
                                      s.tomoenglish == "AP" ? "승인" : "미사용",
                                      s.age_english != null ? (s.age_english == 123 ? "혼합" : "만" + (s.age_english + 2) + "세") : "-",
                                      s.e_quantity,
                                      s.tomoenglish_branch,
                                      s.tomoenglish == "AP"
                                          ? s.tomoenglish_start_date > currentYear + "-06-01"
                                              ? "신규"
                                              : (s.tomoenglish_recontract_year == 0 || s.tomoenglish_recontract_year < currentYear)
                                              ? "재계약"
                                              : "재계약확정"
                                          : "-",
                                  ])
                                : [],
                        },
                    ],
                };
                return excelData;
            },
        };
        var wb = XLSX.utils.book_new();
        var excelData = excelHandler.getExcelData();
        excelData.sheets.forEach((s) => {
            var ws = XLSX.utils.aoa_to_sheet([]);
            XLSX.utils.sheet_add_aoa(ws, [excelData.sheets[0].columnTitle], { origin: { r: 0, c: 0 } });
            XLSX.utils.sheet_add_json(ws, s.data, { origin: { r: 1, c: 0 }, skipHeader: true });

            XLSX.utils.book_append_sheet(wb, ws, s.name);
        });

        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        util.download2Excel(wbout, excelData.fileName);

        setAdjustmenting(false);
    };

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col">
                            <div className="page-header">
                                <h3>
                                    사용자 관리{selectedNurseryId ? " - " + selectedNurseryName : ""}
                                    {selectedNurseryId != null && (
                                        <button className="btn btn-primary btn-rounded" style={{ float: "right" }} onClick={onBackButton}>
                                            목록
                                        </button>
                                    )}
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content pb-5">
                    {selectedNurseryId == null && (
                        <div className="row" style={{ overflow: "hidden" }}>
                            {!isRoleBranch && (
                                <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 pl-4 d-flex" style={{ margin: "7px" }}>
                                    <InputGroup className="">
                                        <InputGroup.Prepend>
                                            <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>지 사</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <ViewOption data={branches} selectedAll={false} selected={selectedViewOption} onOptionSelect={onViewOptionSelected} />
                                    </InputGroup>
                                </div>
                            )}

                            <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 pl-4 d-flex" style={{ margin: "7px" }}>
                                <InputGroup className="">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>원</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <ViewOption data={nurseries} selectedAll={false} selected={selectedViewSubOption} onOptionSelect={onViewSubOptionSelected} />
                                </InputGroup>
                            </div>

                            {isRoleBranch && <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 pl-4 d-flex"></div>}
                            <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 pl-4 d-flex" style={{ margin: "7px", float: "right" }}>
                                <InputGroup className="">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>검색</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <div style={{ width: "80px" }}>
                                        <ViewOption data={searchTypeList} selectedAll={false} selected={searchType} onOptionSelect={onSearchTypeSelected} />
                                    </div>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="검색어를 입력해주세요"
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                        onKeyPress={handleKeyPress}
                                    />
                                    <button className="btn btn-primary" onClick={onSearch}>
                                        검색
                                    </button>
                                </InputGroup>
                            </div>
                        </div>
                    )}
                    {selectedNurseryId == null && (
                        <div className="row">
                            <div className="col">
                                <h5 className="mb-0" style={{ alignSelf: "end", float: "left", marginLeft: "2%" }}>
                                    <span>
                                        {searchCount} / {totalCount}
                                    </span>
                                </h5>
                                {!isRoleBranch && (
                                    <button
                                        className="btn btn-sm btn-outline-secondary float-right"
                                        id="subcontentAdd"
                                        type="button"
                                        style={{ width: 200, marginRight: "10px", float: "right", marginRight: "2%", marginBottom: "10px" }}
                                        onClick={onAdjustmenting}
                                        disabled={adjustmenting}
                                    >
                                        <i className="fas fa-table mr-1"></i>계약 상세 정보 다운로드
                                    </button>
                                )}
                                {!isRoleBranch && (
                                    <button
                                        className="btn btn-sm btn-outline-secondary float-right"
                                        id="subcontentAdd"
                                        type="button"
                                        style={{ width: 200, marginRight: "10px", float: "right", marginRight: "2%", marginBottom: "10px" }}
                                        onClick={onConsultAdjustmenting}
                                        disabled={adjustmenting}
                                    >
                                        <i className="fas fa-table mr-1"></i>정산 참고 자료 다운로드
                                    </button>
                                )}
                                
                            </div>
                        </div>
                    )}
                    {selectedNurseryId == null ? (
                        <div className="col">
                            <List data={tableData} page={Number(page)} row={ROW_PER_PAGE} onSelectPage={onSelectPage} total_cnt={searchCount} onRowSelected={onSelectedRow} />
                        </div>
                    ) : (
                        <div className="col">
                            <NurseryDetail isRoleBranch={isRoleBranch} selectedBranchId={selectedViewOption != "none" ? selectedViewOption : -1} selectedNurseryId={selectedNurseryId != "none" ? selectedNurseryId : null} serviceAppList={serviceAppList} combineAppAuth={combineAppAuth}/>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Subscriber;
